import pino from 'pino';

import { LOG_LEVEL } from '../const';

/**
 * Client-safe logger for code that runs in the browser (or on both sides).
 * It avoids pino-pretty and the Node stream used by the Sentry transport in ./index;
 * in the browser pino writes to the console, on the server to stdout as JSON.
 */
export const logger = pino({
  level: LOG_LEVEL,
  browser: { asObject: false },
});
